import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();
  const [time, setTime] = useState({ h: 5, m: 47, s: 25 });
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(prev => {
        let { h, m, s } = prev;
        s--; if (s < 0) { s = 59; m--; } if (m < 0) { m = 59; h--; } if (h < 0) { h = 23; m = 59; s = 59; }
        return { h, m, s };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => String(n).padStart(2, '0');
  return (
    <section className="py-16 sm:py-20 md:py-28 bg-gradient-to-br from-[#862ce0] via-[#9a38e8] to-[#c026d3] relative overflow-hidden">
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl" />
      </div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10 text-center">
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6">{t('cta.title')}</h2>
        <p className="text-lg sm:text-xl text-white/90 mb-8 sm:mb-10 max-w-2xl mx-auto">{t('cta.desc')}</p>
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-5 py-3 mb-8">
          <span className="text-sm text-white/90">{t('cta.expires')}</span>
          <span className="font-mono font-bold text-amber-300 text-lg">{pad(time.h)}:{pad(time.m)}:{pad(time.s)}</span>
        </div>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="#test" className="inline-flex items-center justify-center bg-white text-primary hover:bg-white/90 font-bold text-lg px-10 py-5 rounded-full transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap">{t('cta.btn1')}</a>
          <a href="#test" className="inline-flex items-center justify-center border-2 border-white/40 text-white hover:bg-white/10 font-semibold text-lg px-10 py-5 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap">{t('cta.btn2')}</a>
        </div>
        <p className="mt-6 text-white/60 text-sm">{t('cta.note')}</p>
      </div>
    </section>
  );
}
